import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslationService } from '@sdbn/common';
import { environment } from 'src/environments/environment';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup } from '@angular/forms';
import { SearchArticle, SearchArticleResult } from '../../erp-common.model';
import { HttpService } from '@sdbn/appclient';

@Component({
  selector: 'app-article-selection',
  templateUrl: './article-selection.component.html',
  styleUrls: ['./article-selection.component.scss']
})
export class ArticleSelectionComponent implements OnInit {

  formGroup = new FormGroup({});

  query = '';

  items = new Array<SearchArticleResult>();

  selected: SearchArticleResult;


  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<SearchArticleResult>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {
    this.formGroup.addControl('query', new FormControl('', []));
  }

  ngOnInit(): void {
    this.formGroup.valueChanges.subscribe(formValues => {
      this.query = formValues.query;
    });
  }

  refreshArticleList() {
    console.log('search articles by query', this.query);

    this.http.postWithContext<SearchArticleResult[]>(environment.erpArticleEndpoint + '/searchArticle',
      new SearchArticle({ query: this.query, includeArchived: false }))
      .subscribe(response => {

        const data = new Array<SearchArticleResult>();

        for (const item of response) {
          data.push(new SearchArticleResult(item));
        }
        this.items = data;
      }, error => {
        console.log('error is', error);
      });
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    this.dialogRef.close(this.selected);
  }

  selectArticle(article: any) {
    this.selected = article;
  }

}
